'use strict';

const $ = window.jQuery;
const colors = [ '#c99d66',
    '#f1bb1c',
    '#f07f42',
    '#ec626b',
    '#f088b6',
    '#9d5b75',
    '#6f9e92',
    '#89cccc',
    '#9abee0',
    '#615fa7' ];

export default function() {
    $( '.menu-sticky__close, .menu-sticky__mobile-close' ).on( 'click', function() {
        $( 'body' ).removeClass( 'noscroll' );
        $( '#menuSticky' ).removeClass( 'is-active' );
    } );

    const $$links = $( '.nav-sticky-l1__link' );

    $$links.hover( function() {
        if ( ! $( this ).hasClass( 'is-active' ) ) {
            $( this ).find( '.i-gesec-top' ).css( {
                'transform': `rotate(${ ( Math.random() * 360 ) + 1 }deg)`,
                'fill': colors[ Math.round( ( Math.random() * 9 ) + 1 ) ],
            } );
        }
    }, function() {
    } );

    $$links.on( 'click', function( e ) {
        $( '.nav-sticky-l1__link' ).not( $( this ) ).removeClass( 'is-active' ).next( '.nav-sticky-l2' ).slideUp();

        if ( $( this ).hasClass( 'menu-item-has-children' ) ) {
            e.preventDefault();

            $( this ).toggleClass( 'is-active' ).next( '.nav-sticky-l2' ).slideToggle();
        }
    } );

    // Close when pressing escape
    $( document ).keyup( ( e ) => {
        if ( e.key === 'Escape' ) {
            $( '.nav-sticky-l1__link' ).next( '.nav-sticky-l2' ).slideUp();
            $$links.removeClass( 'is-active' ).next( '.nav-sticky-l2' ).slideUp();
        }
    } );
};
